"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MenuContainer;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
require("./components/index.scss");
var _Menu = _interopRequireDefault(require("./Menu"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function MenuContainer({
  data,
  children,
  commonStyle,
  domains: domainInfos
}) {
  const _data$configuration = data.configuration,
    configuration = _data$configuration === void 0 ? [] : _data$configuration,
    _data$modTitle = data.modTitle,
    modTitle = _data$modTitle === void 0 ? '' : _data$modTitle,
    _data$isFix = data.isFix,
    isFix = _data$isFix === void 0 ? false : _data$isFix;
  const config = formatData(JSON.parse(JSON.stringify(configuration)));
  return /*#__PURE__*/React.createElement("section", {
    className: "menu-container",
    id: modTitle
  }, modTitle && /*#__PURE__*/React.createElement("div", {
    className: "menu-container-title-swap"
  }, /*#__PURE__*/React.createElement("span", {
    className: "menu-container-title"
  }, modTitle)), /*#__PURE__*/React.createElement(_Menu.default, {
    title: modTitle,
    children: children,
    configuration: config,
    isFix: isFix,
    domains: domainInfos
  }));
}
function formatData(configuration) {
  configuration.forEach((it0, i0) => {
    it0.bindingNum = `audio_${i0}`;
    it0.id = `${i0}`;
    if (!['jump', 'container'].includes(it0.dataType)) {
      if (it0.dataType === 'iconsDesc') {
        it0.pane = {
          iconsDesc: it0.iconsDesc
        };
        delete it0.iconsDesc;
      } else {
        it0.pane = {
          simpleData: it0.simpleData
        };
        delete it0.simpleData;
      }
      const children = it0['pane'][it0.dataType] || [];
      children.forEach((it1, i1) => {
        it1.bindingNum = `${it0.dataType}_${i0}_${i1}`;
        it1.id = `${i0}_${i1}`;
        if (it0.dataType === 'iconsDesc') {
          (it1.children || []).forEach((it2, i2) => {
            it2.bindingNum = `${it0.dataType}_${i0}_${i1}_${i2}`;
            it2.id = `${i0}_${i1}_${i2}`;
            (it2.children || []).forEach((it3, i3) => {
              it3.bindingNum = `${it0.dataType}_${i0}_${i1}_${i2}_${i3}`;
              it3.id = `${i0}_${i1}_${i2}_${i3}`;
              it3.extendProps = {
                'report-event': 'click_tab_two_level',
                'report-ext1': `multi_child_${it3.id}`,
                'report-ext2': it3.txt
              };
            });
          });
        } else {
          it1.extendProps = {
            'report-event': 'click_tab_two_level',
            'report-ext1': `multi_child_${it1.id}`,
            'report-ext2': it1.txt
          };
        }
      });
    }
    it0.extendProps = {
      'report-event': 'click_tab_one_level',
      'report-ext1': `multi_child_${it0.id}`,
      'report-ext2': it0.label
    };
  });
  return configuration;
}